<template>
  <form @submit.prevent="handleSubmit">
    <modal-card title="Шинэ олголт">
      <b-field label="Publisher" style="position: relative;">
        <publisher-select v-if="!publisher" v-model="form.publisher_id"></publisher-select>

        <b-input v-else type="text" v-model="publisher.name" readonly></b-input>
      </b-field>

      <b-field label="Эхний">
        <datepicker v-model="form.start_date"></datepicker>
      </b-field>

      <b-field label="Сүүлийн">
        <datepicker v-model="form.end_date"></datepicker>
      </b-field>

      <b-field label="Орлого хүлээн авах данс">
        <b-select v-model="form.account_id" :loading="accounts.loading" expanded>
          <option v-for="account in accounts.data" :key="account.id" :value="account.id">
            {{ account.bank.name }} / {{ account.number }} &lt;{{
            account.name
            }}&gt;
          </option>
        </b-select>
      </b-field>

      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">Close</button>

        <button class="button is-primary" :class="{ 'is-loading': form.processing }">Save</button>
      </div>
    </modal-card>
  </form>
</template>

<script>
import PublisherSelect from "./selectors/PublisherSelect";

export default {
  components: {
    PublisherSelect
  },

  props: {
    publisher: {
      type: Object,
      default: null
    },

    startDate: String,
    endDate: String,

    dontRedirect: {
      type: Boolean,
      default: false
    },

    whenCreated: {
      type: Function
    }
  },

  data() {
    return {
      form: new window.Form({
        publisher_id: this.publisher ? this.publisher.id : null,
        start_date: this.startDate,
        end_date: this.endDate,
        account_id: null
      }),

      accounts: new window.RemoteCollection(() => {
        return `/admin/api/publishers/${this.form.publisher_id}/accounts`;
      }).filter({ active: true })
    };
  },

  created() {
    this.accounts.load(() => {
      if (this.accounts.data.length > 0) {
        this.form.account_id = this.accounts.data[0].id;
      }
    });
  },

  methods: {
    handleSubmit() {
      this.form.post("/api/publisher-income/distributions").then(data => {
        let distributionId = data.data.id;

        if (this.whenCreated) {
          this.whenCreated(data.data);
        }

        if (!this.dontRedirect) {
          window.app.$router.push(
            "/accounting/distributions/" + distributionId
          );
        }

        this.$parent.close();
      });
    }
  }
};
</script>
